export const LOGIN = "Login";
export const LETS_GET_STARTED = "Let’s get started ";
